<template>
  <div class="animated fadeIn">
     <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="date" label="Tanggal Absensi">
                    <v-date-picker
                      id="date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Absensi', required: '', readonly: ''}"
                      v-model="myDate"
                    ></v-date-picker>
                  </b-form-group>
                </b-col>

                <!-- <b-col sm="3">
                  <b-form-group label-for="filtering" label="Kondisi Tambahan">
                    <model-select
                      id="filtering"
                      :options="filtering"
                      v-model="filValue"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                  </b-form-group>
                </b-col> -->
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="card">
      <div class="card-header">Export data Karyawan</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "report_data_employee",
  components: {
    loading, ModelSelect
  },
  data() {
    return {
        filtering: [
            {value: 'all', text: 'All'},
            {value: 'absent_telat', text: 'Karyawan Absen & Telat Saja'},
            {value: 'ontime', text: 'Karyawan Yang Masuk Tepat Waktu Saja'}
        ],
        currentYear: moment().format("YYYY"),
        currentMonth: moment().format("MM"),
        loading: false,
        myDate: null,
        filValue: 'all'
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = false;
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        if(this.myDate === null) {
          alert('Tanggal Harus di pilih');
        } else {
          // let start = moment(this.myDate.start).format("YYYY-MM-DD");
          // let end = moment(this.myDate.end).format("YYYY-MM-DD");
          let param = {'attendance_date': moment(this.myDate).format("YYYY-MM-DD")};
          this.loading = true;
          this.axios({
            url: "web/export_pdf/attendance/generate_all_attendance/",
            method: "POST",
            data: param,
            responseType: "blob",
            crossdomain: true 
          })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "all-attendance-"+moment(this.myDate).format("DD MMM YYYY")+".pdf");
              document.body.appendChild(link);
              link.click();
            })
            .catch(error => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });


          // let start = moment(this.myDate.start).format("YYYY-MM-DD");
          // let end = moment(this.myDate.end).format("YYYY-MM-DD");
          // //window.location.href = axios.defaults.baseURL+'web/export/data-attendance/'+this.currentMonth+'/'+this.currentYear+'/';
          // window.location.href = axios.defaults.baseURL+'web/export/data-attendance/'+start+'/'+end+'/';
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
